import { RangeSlider, Text } from '@mantine/core';

interface RangeInputProps {
  label: string;
  min: number;
  max: number;
  step: number;
  marks: Array<{ value: number; label: string }>;
  unit?: string;
  value: [number, number];
  onChange: (value: [number, number]) => void;
}

const AgeRangeInput: React.FC<RangeInputProps> = ({
  label,
  min,
  max,
  step,
  marks,
  unit = '',
  value,
  onChange,
}) => {
  return (
    <>
      <Text size="sm" className="font-medium">
        {label}
      </Text>
      <RangeSlider
        mx={10}
        mb={24}
        min={min}
        max={max}
        step={step}
        marks={marks}
        label={(val) => `${val}${unit}`}
        value={value}
        onChange={onChange}
      />
    </>
  );
};

export default AgeRangeInput;
